import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../globals';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
//pages
import { SalesSalesPage } from './reports/sales-sales/sales-sales';
import { SalesAveragePage } from './reports/sales-average/sales-average';
import { SelectBetweenDatetime } from '../components/popups/select-between-datetime/select-between-datetime';
import { AdvancedAnalyticsServices } from './advanced-analytics-services';
import { SalesAveragePerDinerPage } from './reports/sales-average-per-diner/sales-average-per-diner';
import { SalesSalesPerM2Page } from './reports/sales-sales-per-m2/sales-sales-per-m2';
import { SalesZonesPage } from './reports/sales-zones/sales-zones';
import { SalesPerHourPage } from './reports/sales-per-hours/sales-per-hours';
import { ElementsTopSalesPage } from './reports/elements-top-sales/elements-top-sales';
import { ElementsTopSalesCategoryPage } from './reports/elements-top-sales-category/elements-top-sales-category';
import { ElementsFoodcostPage } from './reports/elements-foodcost/elements-foodcost';
import { ElementsAllergensPage } from './reports/elements-allergens/elements-allergens';
import { DeliveryTakeawaySalesPage } from './reports/delivery-takeaway-sales/delivery-takeaway-sales';
import { DeliveryTakeawayPerDayPage } from './reports/delivery-takeaway-per-day/delivery-takeaway-per-day';
import { DeliveryTakeawaySalesTypePage } from './reports/delivery-takeaway-sales-type/delivery-takeaway-sales-type';
import { DeliveryTakeawaySalesMapPage } from './reports/delivery-takeaway-sales-map/delivery-takeaway-sales-map';
import { DeliveryTakeawaySalesElementsPage } from './reports/delivery-takeaway-sales-elements/delivery-takeaway-sales-elements';
import { DeliveryTakeawaySalesCategoriesPage } from './reports/delivery-takeaway-sales-categories/delivery-takeaway-sales-categories';
import { WaitersSalesPage } from './reports/waiters-sales/waiters-sales';
import { WaitersMovementsPage } from './reports/waiters-movements/waiters-movements';
import { PurchasesTotalPage } from './reports/purchases-total/purchases-total';
import { PurchasesPerElementPage } from './reports/purchases-per-element/purchases-per-element';
import { PurchasesPerProviderPage } from './reports/purchases-per-provider/purchases-per-provider';
import { CustomersTotalPage } from './reports/customers-total/customers-total';
import { CustomersNewPage } from './reports/customers-new/customers-new';
import { CustomersSalesPage } from './reports/customers-sales/customers-sales';
import { CustomersRetentionPage } from './reports/customers-retention/customers-retention';
import { StockSummaryPage } from './reports/stock-summary/stock-summary';
import { SalesPersonsPerDayPage } from './reports/sales-persons-per-day/sales-persons-per-day';
import { SalesPaymentMethodsUsedPage } from './reports/sales-payment-methods-used/sales-payment-methods-used';
import { SalesFoodcostPage } from './reports/sales-foodcost/sales-foodcost';
import { SalesDiscountsPage } from './reports/sales-discounts/sales-discounts';
import { SalesTipsPage } from './reports/sales-tips/sales-tips';
import { ReservationsTotalPage } from './reports/reservations-total/reservations-total';
import { ReservationsAvgPersonsPerStripePerDayPage } from './reports/reservations-avg-persons-per-stripe-per-day/reservations-avg-persons-per-stripe-per-day';
import { ReservationsTopCustomersPage } from './reports/reservations-top-customers/reservations-top-customers';
import { KitchenTotalOrdersPage } from './reports/kitchen-total-orders/kitchen-total-orders';
import { KitchenDurationToCompleteDishPage } from './reports/kitchen-duration-to-complete-dish/kitchen-duration-to-complete-dish';
import { PurchasesPerCategoryPage } from './reports/purchases-per-category/purchases-per-category';
import { ReservationsAnulatedPage } from './reports/reservations-anulated/reservations-anulated';
import { SalesPerWeekPage } from './reports/sales-per-week/sales-per-week';
import { KitchenTotalOrdersElementsPage } from './reports/kitchen-total-orders-elements/kitchen-total-orders-elements';
import { KitchenAvgTimeCompleteOrderPage } from './reports/kitchen-avg-time-complete-order/kitchen-avg-time-complete-order';
import { StockPercentageSalesPerDayPage } from './reports/stock-percentage-sales-per-day/stock-percentage-sales-per-day';
import { StockDaysInventoryLeftPage } from './reports/stock-days-inventory-left/stock-days-inventory-left';
import { StockCogsPage } from './reports/stock-cogs/stock-cogs';
import { StockAbcPage } from './reports/stock-abc/stock-abc';
import { ProductionOrderPage } from './reports/production-order/production-order';

/**
 * Generated class for the AnalyticsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-analytics',
  templateUrl: 'analytics.html',
})
export class AnalyticsPage {

  show_report_list_sales = false;
  show_report_list_elements = false;
  show_report_list_dv_tk = false;
  show_report_list_waiters = false;
  show_report_list_stock = false;
  show_report_list_purchases = false;
  show_report_list_reservations = false;
  show_report_list_customers = false;
  show_report_list_kitchen = false;
  show_report_list_foodcost = false;

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData()
      }
    });
    profileModal.present();
  }


  report_list_sales = [
    {
      title: this.translate.instant('general-facturacion'),
      push: SalesSalesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-propinas'),
      push: SalesTipsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-descuentos'),
      push: SalesDiscountsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('sales-analytics-facturacion-medias'),
      push: SalesAveragePage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-precio-medio-x-comensal-servido'),
      push: SalesAveragePerDinerPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-ingresos-x-metro-2-disponible'),
      push: SalesSalesPerM2Page,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-ventas-x-zona'),
      push: SalesZonesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-ocupacion-x-horas'),
      push: SalesPerHourPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-ocupacion-x-dias'),
      push: SalesPersonsPerDayPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-dia-semana-mas-ventas-tickets-comensales'),
      push: SalesPerWeekPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-fuente-ingresos'),
      push: SalesPaymentMethodsUsedPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-foodcost'),
      push: SalesFoodcostPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    }
  ];
  report_list_elements = [
    {
      title: this.translate.instant('sales-analytics-elementos-mas-vendidos'),
      push: ElementsTopSalesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-categorias-mas-vendidas'),
      push: ElementsTopSalesCategoryPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-listado-foodcost'),
      push: ElementsFoodcostPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-analitica-listado-alergenos'),
      push: ElementsAllergensPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-prevision-platos'),
      push: ProductionOrderPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_dv_tk = [
    {
      title: this.translate.instant('general-facturacion-takeaway-delivery'),
      push: DeliveryTakeawaySalesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-tickets-x-dia-takeaway-delivery'),
      push: DeliveryTakeawayPerDayPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-facturacion-x-tipo-takeaway-delivery'),
      push: DeliveryTakeawaySalesTypePage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-mapa-tickets-donde-se-reparten'),
      push: DeliveryTakeawaySalesMapPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-elementos-mas-vendidos-x-takeaway-delivery'),
      push: DeliveryTakeawaySalesElementsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-categorias-mas-vendidas-x-takeaway-delivery'),
      push: DeliveryTakeawaySalesCategoriesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_waiters = [
    {
      title: this.translate.instant('general-facturacion'),
      push: WaitersSalesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('sales-analytics-movimientos'),
      push: WaitersMovementsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_stock = [
    {
      title: this.translate.instant('general-dias-de-inventario-restantes'),
      push: StockDaysInventoryLeftPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-analisis-abc-x-producto'),
      push: StockAbcPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-inventario-promedio-vendido-x-dia'),
      push: StockPercentageSalesPerDayPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-resumen-inventario-dia-indicado'),
      push: StockSummaryPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-costo-bienes-vendidos'),
      push: StockCogsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_purchases = [
    {
      title: this.translate.instant('general-compras-total'),
      push: PurchasesTotalPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-compras-x-elemento'),
      push: PurchasesPerElementPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-compras-x-categoria'),
      push: PurchasesPerCategoryPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-comprar-x-proveedor'),
      push: PurchasesPerProviderPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_reservations = [
    {
      title: this.translate.instant('general-total-reservas'),
      push: ReservationsTotalPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-reserva-x-dias-x-franja-media-comensales'),
      push: ReservationsAvgPersonsPerStripePerDayPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-top-clientes-mas-reservas'),
      push: ReservationsTopCustomersPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-anulaciones-reserves'),
      push: ReservationsAnulatedPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_customers = [
    {
      title: this.translate.instant('general-total-clientes'),
      push: CustomersTotalPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-clientes-nuevos'),
      push: CustomersNewPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-listado-clientes-mas-facturacion'),
      push: CustomersSalesPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-retencion-clientes'),
      push: CustomersRetentionPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];
  report_list_kitchen = [
    {
      title: this.translate.instant('general-pedidos-totales'),
      push: KitchenTotalOrdersPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-numero-de-elementos-en-cocina'),
      push: KitchenTotalOrdersElementsPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-tiempo-medio-completar-pedidos'),
      push: KitchenAvgTimeCompleteOrderPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
    {
      title: this.translate.instant('general-duracion-en-preparar-platos'),
      push: KitchenDurationToCompleteDishPage,
      access: this.globals.checkLimitsByLicense('analytics', 'analytics'),
    },
  ];


  total_sales = 0;
  total_tips = 0;
  total_with_tips = 0;
  total_elements_sold = 0;
  total_delivery = 0;
  movements = 0;
  stock_value: any = 0;
  purchases_total: any = 0;
  total_reservations: any = 0;
  new_customers: any = 0;
  kitchen_elements: any = 0;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    private modalCtrl: ModalController,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public http: HttpClient) {
  }

  ionViewWillEnter() {
    this.advancedAnalyticsServices.limitDays();
    this.getAnalyticsData();
    if (this.navParams.get('scroll_id')) {
      document.getElementById(this.navParams.get('scroll_id')).scrollIntoView();
    }
    this.globals.GAtrackView('Analytics', 'Analytics - View', this.globals.restaurant.email, 'View', 'View analytics', 'Analytics', '');
  }

  ionViewWillLeave() {
    //this.advancedAnalyticsServices.resetLimitDays();
  }

  async getAnalyticsData() {
    //call functions to get data
    this.getTotalSales();
    this.getTotalElementsSold();
    this.getDeliveryTotal();
    this.getWaitersMovements();
    this.getStockValue();
    this.getPurchasesTotal();
    this.getTotalReservations();
    this.getNewCustomers();
    this.getKitchenElements();
  }

  async getTotalSales() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/sales_total', params, {})
      .subscribe(async response => {
        this.total_sales = response['total_sales'];
        this.total_tips = response['total_tips'];
        this.total_with_tips = response['total_with_tips'];
      });
  }

  async getTotalElementsSold() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/elements_total_sold', params, {})
      .subscribe(async response => {
        this.total_elements_sold = response['total_elements_sold'];
      });
  }

  async getDeliveryTotal() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/delivery_total', params, {})
      .subscribe(async response => {
        this.total_delivery = response['sales'];
      });
  }

  async getWaitersMovements() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/waiters_movements', params, {})
      .subscribe(async response => {
        this.movements = response['movements'];
      });
  }

  async getStockValue() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/stock_value', params, {})
      .subscribe(async response => {
        this.stock_value = response;
        this.stock_value = parseFloat(this.stock_value);
      });
  }

  async getPurchasesTotal() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/purchases_total', params, {})
      .subscribe(async response => {
        this.purchases_total = response['total'];
      });
  }
  async getTotalReservations() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/reservations_total', params, {})
      .subscribe(async response => {
        this.total_reservations = response['total'];
      });
  }
  async getNewCustomers() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/customers_new_customers', params, {})
      .subscribe(async response => {
        this.new_customers = response['total'];
      });
  }

  async getKitchenElements() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/kitchen_total_finish_elements', params, {})
      .subscribe(async response => {
        this.kitchen_elements = response;
      });
  }

  //
  change_show_report_list(type) {
    switch (type) {
      case 'report_list_sales':
        this.show_report_list_sales = !this.show_report_list_sales;
        break;
      case 'report_list_elements':
        this.show_report_list_elements = !this.show_report_list_elements;
        break;
      case 'report_list_dv_tk':
        this.show_report_list_dv_tk = !this.show_report_list_dv_tk;
        break;
      case 'report_list_waiters':
        this.show_report_list_waiters = !this.show_report_list_waiters;
        break;
      case 'report_list_stock':
        this.show_report_list_stock = !this.show_report_list_stock;
        break;
      case 'report_list_purchases':
        this.show_report_list_purchases = !this.show_report_list_purchases;
        break;
      case 'report_list_reservations':
        this.show_report_list_reservations = !this.show_report_list_reservations;
        break;
      case 'report_list_customers':
        this.show_report_list_customers = !this.show_report_list_customers;
        break;
      case 'report_list_kitchen':
        this.show_report_list_kitchen = !this.show_report_list_kitchen;
        break;
      case 'report_list_foodcost':
        this.show_report_list_foodcost = !this.show_report_list_foodcost;
        break;
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/analytics/analytics.ts